import CreatePageContainer from "../../../Component/Reports/CreateReport/CreatePage"

const CreatePage = () => {
  return (
    <div className='page-body'>
      <CreatePageContainer />
    </div>
  )
}

export default CreatePage